import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import ls from 'local-storage'
import { useLocation, useNavigate } from "react-router-dom";
import formatter from "src/reusables/formatter";
import { getReview } from "src/services/Reviews";
import { getTransactionListById } from "src/services/Transactions";

const { CCard, CCardHeader, CButton, CCardBody, CCol, CRow, CFormLabel, CFormInput, CImage, CFormText, CFormTextarea } = require("@coreui/react");

const PHOTO_RESULT_BASE_URL = 'memories.sukhakala.id/?id='

function ReviewDetails() {
    const [review, setReview] = useState({})
    const [transaction, setTransaction] = useState({})
    const [id, setId] = useState(ls.get("reviewId"))

    const navigate = useNavigate()

    function fetchReview() {
        getReview(id).then(response => {
            setReview(response.data)
        })
    }

    function fetchTransaction() {
        getTransactionListById(review.transaction_id).then(response => {
            setTransaction(response.data[0])
        })
    }

    useEffect(() => {
        fetchReview()
    }, [])

    useEffect(() => {
        if (review.transaction_id) {
            fetchTransaction()
        }
    }, [review])

    useEffect(() => {
        console.log(transaction)
    }, [transaction])

    return (
        <>
            <Grid container className="mb-3">
                <Grid item>
                    <CButton
                        onClick={() => navigate('/reviews')}
                    >
                        Back
                    </CButton>
                </Grid>
            </Grid>
            <CCard className="mb-3">
                <CCardHeader>
                    <h3>
                        Review Detail
                    </h3>
                </CCardHeader>
                <CCardBody>
                    <CCol>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">ID</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.id} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Merchant</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.merchant_name} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Booth ID</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.booth_id} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Rating</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.rating} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Name</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.name} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Gender</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.gender} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Date of Birth</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.date_of_birth ? formatter('completeDate', review.date_of_birth).split(',')[0] : '-'} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Phone</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.phone} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Email</CFormLabel>
                            </CCol>
                            <CCol>
                                <CFormInput value={review.email} readOnly plainText />
                            </CCol>
                        </CRow>
                        <CRow className="mb-1">
                            <CCol>
                                <CFormLabel className="col-form-label">Description</CFormLabel>
                            </CCol>
                            <CCol>
                                {review.description ?? '-'}
                            </CCol>
                        </CRow>
                    </CCol>
                </CCardBody>
            </CCard>
            <CCard className="mb-3">
                <CCardHeader>
                    <h3>
                        Transaction Detail
                    </h3>
                </CCardHeader>
                <CCardBody>
                    <CRow>
                        <CCol>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">ID</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={transaction.id} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Paid At</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={formatter('completeDate', transaction.paidAt)} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Done At</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={transaction.doneAt ? formatter('completeDate', transaction.doneAt) : '-'} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Duration</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={`${transaction.duration} minutes`} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Price</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={formatter('currency', transaction.price ?? 0)} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Discount</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={formatter('currency', transaction.discount ?? 0)} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Grand Total</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={formatter('currency', transaction.grand_total ?? 0)} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Voucher Code</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={transaction.voucherCode} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Frame</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={transaction.frameName} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Timeout</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={transaction.timeout} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Happy Hour</CFormLabel>
                                </CCol>
                                <CCol>
                                    <CFormInput value={transaction.is_happy_hour == 1 ? 'Yes' : 'No'} readOnly plainText />
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Photo Result</CFormLabel>
                                </CCol>
                                <CCol>
                                    {transaction.uuid ? `${PHOTO_RESULT_BASE_URL}${transaction.uuid}` : '-'}
                                </CCol>
                            </CRow>
                            <CRow className="mb-1">
                                <CCol>
                                    <CFormLabel className="col-form-label">Image</CFormLabel>
                                </CCol>
                                <CCol>
                                    {
                                        transaction.imageURL ?
                                            (transaction.imageURL.includes('Failed To Upload') ? (
                                                <p>{transaction.imageURL}</p>
                                            ) : (
                                                <CImage width="300vh" src={transaction.imageURL ?? ''} />
                                            )) :
                                            '-'
                                    }
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                </CCardBody>
            </CCard>
        </>
    )
}

export default ReviewDetails